import { useEffect, useState } from "react";

const ORIGIN = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

// A foto fica no backend como um link curto (ex: /files/avatars/abc.jpg).
export function resolveAvatarUrl(url) {
  if (!url) return null;
  return url.startsWith("/") ? `${ORIGIN}${url}` : url;
}

const TONES = [
  "bg-orange-500/20 text-orange-300",
  "bg-sky-500/20 text-sky-300",
  "bg-emerald-500/20 text-emerald-300",
  "bg-violet-500/20 text-violet-300",
  "bg-rose-500/20 text-rose-300",
  "bg-amber-500/20 text-amber-300",
];

function hashOf(str) {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

export function initialsOf(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2);
  return parts[0][0] + parts[parts.length - 1][0];
}

// Foto da pessoa; se nao tiver (ou nao abrir), mostra as iniciais numa cor fixa.
export default function UserAvatar({ url, name = "", size = 40, className = "", rounded = "rounded-full" }) {
  const [failed, setFailed] = useState(false);
  const src = resolveAvatarUrl(url);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const style = { width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.38)) };

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={name}
        style={style}
        className={`shrink-0 bg-muted object-cover ${rounded} ${className}`}
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <div
      style={style}
      aria-label={name}
      className={`grid shrink-0 place-items-center font-semibold uppercase ${TONES[hashOf(name) % TONES.length]} ${rounded} ${className}`}
    >
      {initialsOf(name)}
    </div>
  );
}
